// const backEnd = "http://localhost:5008/";
// const backEnd = "https://backendlivejapan-ykqw6xki6a-an.a.run.app/";
// const backEnd = process.env.NODE_ENV === 'production' ? 'https://storage.googleapis.com/liviejapan-static-file/' : 'https://storage.googleapis.com/liviejapan-static-file/';
// gcp
// const backEnd = process.env.NODE_ENV === 'production' ? 'https://liviejapan-static-file.storage.googleapis.com/' : 'https://liviejapan-static-file.storage.googleapis.com/';
// prod
const backEnd = process.env.NODE_ENV === 'production' ? 'https://livejapan-static-file.storage.googleapis.com/' : 'https://livejapan-static-file.storage.googleapis.com/';
module.exports = backEnd;
